import { render } from "./WidgetConfigModal.vue?vue&type=template&id=0b60c0f3&scoped=true"
import script from "./WidgetConfigModal.vue?vue&type=script&lang=js"
export * from "./WidgetConfigModal.vue?vue&type=script&lang=js"

import "./WidgetConfigModal.vue?vue&type=style&index=0&id=0b60c0f3&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b60c0f3"]])

export default __exports__